import React, { Component } from 'react'
import { connect } from 'react-redux';

import {
    listaDocumentos,
    select_doc,
    selected_doc_remove,
    addDados
} from '../../actions'
import Tags from '../../components/Tags';
import { ToastContainer, toast } from 'react-toastify';

class Lista extends Component {

    constructor(){
        super()
        this.state = {   
            page: 1,
            limit: 10
        }
    }

    componentDidMount(){
        const { documentos, load_doc } = this.props.documentos
        const { page, limit } = this.state
        if( documentos.length == 0 && !load_doc) this.props.listaDocumentos({ page, limit })
    }

    qntLinks(){
        const { paginate } = this.props.documentos
        let qntArray;

        if (paginate.lastPage <= 10) {
            qntArray = new Array(paginate.lastPage).fill(1);

            return qntArray.map((v,i) => {
                return paginate.page === i+1
                    ? (<li key={'link'+i} className="page-item"><a className="page-link" style={{ backgroundColor: '#DCDCDC' }} href="#" onClick={() => this.pagination(i+1)}>{i+1}</a></li>)
                    : (<li key={'link'+i} className="page-item"><a className="page-link" href="#" onClick={() => this.pagination(i+1)}>{i+1}</a></li>)
            })
        } else {
            qntArray = new Array(7).fill(1);
            if (paginate.page <= 3) {
                return qntArray.map((v, i) => {
                    if (i < 5) {
                        return paginate.page === i+1
                            ? (<li key={'link'+i} className="page-item"><a className="page-link" style={{ backgroundColor: '#DCDCDC' }} href="#" onClick={() => this.pagination(i+1)}>{i+1}</a></li>)
                            : (<li key={'link'+i} className="page-item"><a className="page-link" href="#" onClick={() => this.pagination(i+1)}>{i+1}</a></li>)
                    } else if (i === 5) {
                        return (<li key={'etc1'} className="page-item"><a className="page-link">{'...'}</a></li>)
                    } else {
                        return (<li key={'link'+i} className="page-item"><a className="page-link" href="#" onClick={() => this.pagination(paginate.lastPage)}>{paginate.lastPage}</a></li>)
                    }
                })
            } else if (paginate.lastPage - paginate.page <= 3) {
                return qntArray.map((v, i) => {
                    if (i > 1) {
                        const page = paginate.lastPage - 7 + i + 1;
                        return paginate.page === page
                            ? (<li key={'link'+i} className="page-item"><a className="page-link" style={{ backgroundColor: '#DCDCDC' }} href="#" onClick={() => this.pagination(page)}>{page}</a></li>)
                            : (<li key={'link'+i} className="page-item"><a className="page-link" href="#" onClick={() => this.pagination(page)}>{page}</a></li>)
                    } else if (i === 1) {
                        return (<li key={'etc1'} className="page-item"><a className="page-link">{'...'}</a></li>)
                    } else {
                        return (<li key={'link'+i} className="page-item"><a className="page-link" href="#" onClick={() => this.pagination(1)}>{1}</a></li>)
                    }
                })
            } else {
                return qntArray.map((v, i) => {
                    if (i === 0) {
                        return (<li key={'link'+i} className="page-item"><a className="page-link" href="#" onClick={() => this.pagination(1)}>{1}</a></li>)
                    } else if (i === 1) {
                        return (<li key={'etc1'} className="page-item"><a className="page-link">{'...'}</a></li>)
                    } else if (i === 2) {
                        return (<li key={'link'+i} className="page-item"><a className="page-link" href="#" onClick={() => this.pagination(paginate.page - 1)}>{paginate.page - 1}</a></li>)
                    } else if (i === 3) {
                        return (<li key={'link'+i} className="page-item"><a className="page-link" style={{ backgroundColor: '#DCDCDC' }} href="#" onClick={() => this.pagination(paginate.page)}>{paginate.page}</a></li>)
                    } else if (i === 4) {
                        return (<li key={'link'+i} className="page-item"><a className="page-link" href="#" onClick={() => this.pagination(paginate.page + 1)}>{paginate.page + 1}</a></li>)
                    } else if (i === 5) {
                        return (<li key={'etc2'} className="page-item"><a className="page-link">{'...'}</a></li>)
                    } else {
                        return (<li key={'link'+i} className="page-item"><a className="page-link" href="#" onClick={() => this.pagination(paginate.lastPage)}>{paginate.lastPage}</a></li>)
                    }
                })
            }
        }
    }

    pagination(page){
        const { paginate, filtroStatus } = this.props.documentos
        // console.log('======== DOCUMENTOS - PAGE: ', page)
        // console.log('======== DOCUMENTOS - PAGE STATE: ', this.state.page)

        if(page >= 1 && page <= paginate.lastPage) {                
            this.setState({
                page: page   
            })
            var { tag, numero, dataInicial, dataFinal, usuario, limit } = this.state
            
            if(usuario == undefined) usuario = ''
            
            this.props.listaDocumentos({ tag, numero, dataInicial, dataFinal, status: filtroStatus, usuario, page, limit })
        }
    }

    selectDoc(doc){
        this.props.select_doc(doc)
    }

    getData(doc){
        let date = ''
        if(doc.status.toLowerCase() == 'em processo') date = doc.dataLimite.split('-')[0]

        return date
    }

    action = (event) => {
        let value = event.target.value
        let name = event.target.name
        this.setState({ [name]:value })
    }

    onSubmit(event){
        event.preventDefault()
        const { tag, numero, titulo, dataInicial, dataFinal, limit } = this.state

        // AO PESQUISAR VOLTA SEMPRE PARA A PRIMEIRA PÁRINA
        let { page } = this.state
        page = 1

        const { filtroStatus } = this.props.documentos
        this.props.listaDocumentos({ tag, numero, dataInicial, titulo, dataFinal, status: filtroStatus, page, limit })
    }

    statusSig(status){
        if(status == null || status == undefined) return ''
        try{
            status = status.split('às')
            return status[0]
        }catch(error){
            return status
        }
    }

    render() {
        const { documentos, load_doc, tags, filtroStatus } = this.props.documentos
        return( 
            <main role="main" className="col-md-10 ml-sm-auto col-lg-10 px-3">
                    {/* <!-- breadcrumb --> */}
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb mt-3 ">
                            <li className="breadcrumb-item active" aria-current="page">Documentos</li>
                        </ol>
                    </nav>

                    {/* <!-- Container --> */}
                    <div className="bg-white rounded shadow-sm p-3">

                        <h6 className="pb-2 mb-0">Filtros</h6>
                       
                        <form onSubmit={ event => this.onSubmit(event)} className='border-bottom border-gray' style={{ marginBottom: 10, paddingTop: 10, paddingBottom: 10 }}>
                            <div style={{ display:'flex', flexWrap: 'wrap'}}>
                                
                                <div style={{ maxWidth: 150, marginBottom: 8, marginRight: 8 }}>
                                    <span>Status:</span>
                                    <select name='status' className="form-control form-group" 
                                        onChange={(event) => this.props.addDados({ filtroStatus: event.target.value }) }
                                        value={filtroStatus || ''} >
                                        <option value={''}>Todos</option>
                                        <option value={'aberto'}>Em processo</option>
                                        <option value={'finalizado'}>Concluidos</option>
                                        <option value={'cancelado'}>Cancelado</option>           
                                    </select>
                                </div>

                                <div style={{ maxWidth: 150, marginBottom: 8, marginRight: 8 }}>
                                    <span>Grupo:</span>
                                    <Tags tags={tags} action={(value) => this.action(value, 'tag')} />
                                </div>

                                <div className="form-group" style={{ marginRight: 8 }}>
                                    <span>Contrato:</span>
                                    <input name="numero" type="text" value={this.state.numero} className="form-control" placeholder="Número" onChange={(event) => this.action(event)} />
                                </div>

                                <div className="form-group" style={{ marginRight: 8 }}>
                                    <span>Nome do documento:</span>
                                    <input name="titulo" type="text" value={this.state.titulo} className="form-control" placeholder="Nome do documento" onChange={(event) => this.action(event)} />
                                </div>

                                <div className="form-group" style={{ marginRight: 8 }}>
                                    <span>Data Inicio:</span>
                                    <input name="dataInicial" type="date" value={this.state.dataInicial} className="form-control" placeholder="Data Inicio" onChange={(event) => this.action(event)} />
                                </div>


                                <div className="form-group" style={{ marginRight: 8 }}>
                                    <span>Data Fim:</span>
                                    <input name="dataFinal" type="date" value={this.state.dataFinal} className="form-control" placeholder="Data Fim" onChange={(event) => this.action(event)} />
                                </div>
                            </div>
                            
                            
                            <button disabled={load_doc} className="btn my-2 my-sm-0 btn-primary" type="submit">Pesquisar</button>
                        </form>
                        
                        <h6 className="border-bottom border-gray pb-2 mb-0">Ultimos documentos</h6>

                        {/* loading */}
                        {load_doc
                            ?<div className="spinner-border" role="status" style={{margin:'5%'}}>
                                <span className="sr-only">Loading...</span>
                            </div>
                            :null
                        }

                        <div style={{ display:'flex', flexDirection:'column' }}>
                            {documentos.map( (v,i) => {
                                if(i >= 0 && i < this.props.documentos.paginate.perPage){
                                const tipoStyleDoc = (v.status || '').toLowerCase().includes('finalizado') ? 'green' : (v.status || '').toLowerCase().includes('cancelado') ? 'red' : 'yellow' 
                                return (
                                    <div className="media text-muted pt-2 " key={'doc-'+v.id} style={{ marginRight: 8, minWidth: '16rem',display:'flex', justifyContent:'center' }}>
                                        <img src={`/assets/imagem/${tipoStyleDoc}-circle.png`} style={{ width: 18, height: 18, marginRight: 3}}/>
                                        <div className="media-body lh-125 border-bottom border-gray">                                           
                                            
                                            {/* <div style={{ display: 'flex'}}> */}
                                                
                                                <strong >                                                
                                                    <a style={{cursor:'pointer',color:'#00406d'}} onClick={() => this.selectDoc(v)} className="h7">{v.titulo}</a>
                                                    {v.numero && <span style={{ marginLeft: 5, textTransform:'uppercase', fontSize: 12}} className={`badge`}>{v.numero}</span>}
                                                    <br />
                                                    <small className="ml-0">{v.assinaturas}</small>                                            
                                                    {v.tag && <span style={{ marginLeft: 5, textTransform:'uppercase' , fontSize: 10}} className={`badge badge-primary`}>{v.tag}</span>}
                                                    <br />
                                                    {v.user != undefined && <small className="ml-0">Enviado por: <strong>{v.user.nome}</strong></small> }
                                                </strong>
                                            {/* </div> */}


                                            {/* <span className="row pl-3 mt-1">
                                                <span className="text-center"></span>
                                                <span className={`badge badge-${tipoStyleDoc}`}>{v.status} {this.getData(v)}</span>
                                            </span> */}


                                            <span className="row pl-2" style={{ marginBottom: 5}}>
                                                {v.signatarios.map ( (s, i) => {
                                                    const tipoStyle = (s.pivot.status || '').toLowerCase().search(/assinado|finalizado/gi) > -1 ? 'success' : 'warning' 
                                                    return (
                                                        <div className="m-1" style={{ minWidth:'6.5rem', maxWidth: '15.5rem', padding: '0.1rem', borderLeft:'1.2px solid #dee2e6' }} key={'sig-'+s.id}>
                                                            <div className="card-body" style={{ padding:'0.2rem'}}>
                                                                <p className="card-title" style={{ marginBottom: 2, fontSize: 12 }}>{s.nome}</p>
                                                                {/* <p className="card-text" style={{ marginBottom: 5 }}>{s.pivot.tipo}</p> */}
                                                                <span className={`badge badge-pill badge-${tipoStyle}`} style={{ fontSize: 9}}>{this.statusSig(s.pivot.status)}</span>
                                                            </div>
                                                        </div>
                                                    )
                                                })
                                                }


                                                {v.signatarios.length == 0
                                                    ?<div className="card m-3 " style={{ border:'0px', width:'14rem' }}>
                                                        <div className="card-body">
                                                            <h6 className="card-title"></h6>
                                                            <p className="card-text"></p>
                                                        </div>
                                                    </div>
                                                    :null
                                                }
                                            </span>
                                        </div>
                                        
                                        {/* <div style={{ width: 0, backgroundColor:'#dee2e6', height: '80%', marginRight: 10, marginLeft: 2 }}></div> */}
                                    </div>
                                )}
                            } )}
                        </div>                       

                        <nav aria-label="Page navigation example">
                            <ul className="pagination mt-3" style={{ flexWrap:'wrap'/*, justifyContent: 'center'*/ }}>
                                <li className="page-item">
                                    <button className="page-link" aria-label="Previous" onClick={ () => this.pagination(this.state.page-1)}>
                                            <span aria-hidden="true">&laquo;</span>
                                            <span className="sr-only">Previous</span>
                                    </button>
                                </li>
                                {
                                    this.qntLinks()
                                }
                                
                                <li className="page-item">
                                    <button className="page-link" aria-label="Next" onClick={ () => this.pagination(this.state.page+1)}>
                                            <span aria-hidden="true">&raquo;</span>
                                            <span className="sr-only" >Next</span>
                                    </button>
                                </li>
                            </ul>
                        </nav>

                    </div>
                    <ToastContainer autoClose={3000} position={toast.POSITION.BOTTOM_CENTER} draggable={false}/>

                </main>
        )
    }
}

const mapStateToProps = ({ documentos, auth }) => {
    return {
        auth,
        documentos,
    }
}

export default connect(mapStateToProps, {
    listaDocumentos,
    select_doc,
    selected_doc_remove,
    addDados
})(Lista);